import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { LoadableLinkedNotification } from './loadable';
import { selectQuery } from '../../../ReduxStorage/location/selectors';
import { currentUserIdSelector } from '../../../ReduxStorage/Auth/selectors';

export const ShouldLoadLinkedNotification = ({ currentUserId, query }) => {
  if (currentUserId && query.has('channelId')) {
    return <LoadableLinkedNotification />;
  }
  return null;
};

ShouldLoadLinkedNotification.propTypes = {
  query: ImmutablePropTypes.map.isRequired,
  currentUserId: PropTypes.string,
};

ShouldLoadLinkedNotification.defaultProps = {
  currentUserId: null,
};

const mapState = (state) => {
  return {
    query: selectQuery(state),
    currentUserId: currentUserIdSelector(state),
  };
};
export const ConnectedLoadableLinkedNotification = connect(mapState)(
  ShouldLoadLinkedNotification
);
